import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import type { ArchivePageTitleProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArchivePageTitleProps';

import STYLES from './ArchivePageTitle.module.scss';

const ArchivePageTitle = ({ title }: ArchivePageTitleProps) => (
  <div className={STYLES.ArchivePageTitle}>
    <BpkText tagName="h1" textStyle={TEXT_STYLES.hero5}>
      {title}
    </BpkText>
  </div>
);

export default ArchivePageTitle;
